'use strict';

import stateConfig from './state_config';

export default function appConfig (
  $provide,
  $httpProvider,
  $sceDelegateProvider,
  $stateProvider,
  $locationProvider,
  $animateProvider,
  $translateProvider,
  resourceProvider,
  config
) {
  'ngInject';

  // Config $http service
  $httpProvider.interceptors.push('authInterceptor');
  $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  // Config states
  angular.forEach(stateConfig, function (config, stateName) {
    $stateProvider.state(stateName, angular.extend({
      resolve: {
        user: [
          'userModel',

          function (userModel) {
            return userModel.itemPromise;
          }
        ]
      }
    }, config));
  });
  $locationProvider.html5Mode(true);


  $sceDelegateProvider.resourceUrlWhitelist([

    'self',
    'https://player.vimeo.com/video/**',
    'http://player.vimeo.com/video/**'
  ]);

  $animateProvider.classNameFilter(/is\-ngAnimationEnabled/);


  // Config angular-translate
  $translateProvider.useLoader('translationLoader');
  $translateProvider.useMessageFormatInterpolation();
  $translateProvider.preferredLanguage('en');
  $translateProvider.useSanitizeValueStrategy('escapeParameters');

  // Config resource
  resourceProvider.config({ baseUrl: config.apiBaseUrl });
  resourceProvider.config({ baseUrlV2: config.apiBaseUrlV2 });

  // $ravenProvider.development(!config.sentryDsn);

  // Decorate
  $provide.decorator('$uiViewScroll', [
    '$window',
    '$timeout',
    '$state',
    '$previousState',
    'scrollTop',

    function ($window, $timeout, $state, $previousState, scrollTop) {
      function getParentStateName(state) {
        return state && state.name.split('.')[0];
      }

      return function () {
        var currentState = $state.current;
        var isSticky = Boolean(currentState.sticky);
        var parentName = getParentStateName(currentState);
        var previousState = $previousState.get();
        var previousParentStateName = getParentStateName(previousState && previousState.state);

        if (!previousState || !isSticky || parentName !== previousParentStateName) {
          $timeout(function () {
            scrollTop(0);
          }, 0, false);
        }
      };
    }
  ]);
}



// WEBPACK FOOTER //
// ./app/src/app.config.js